
import { combineReducers } from 'redux';

import activeLink from './activelink';
import siteData from './siteData';
import currentCategory from './category';
import currentArticle from './article';
import currentText from './selectedText';
import viewCounter from './counter';
import menuOpen from './mobileMenu';

export default combineReducers({
  activeLink, siteData, currentArticle, currentCategory, currentText, viewCounter, menuOpen
}) 